export default [
    {
        path: '/payments/form/:pay/:type',
        component: () => import('./payment.vue'),
        props: true,
    },
    {
        path: '/payments/form/:pay/:type/:id',
        component: () => import('./payment.vue'),
        props: true,
    },
    {
        path: '/payments/form/:pay/:type/:id/:date',
        component: () => import('./payment.vue'),
        props: true,
    },
]
